import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { consultaUser } from './PefilFunction';

export const NotActiacion = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}consultMateriasIns`, Content, (resp) => {
            let data = JSON.parse(resp)
            let contenido = []
            if(data.status === "ok"){
                let cont = data.contenido;
                for (let i in cont){
                    let tipo = "";
                    switch (parseInt(cont[i].tipo_curso)) {
                        case 0:
                            tipo = 'Presencial';
                            break;
                        case 1:
                            tipo = 'Prueba de Suficiencia' ;
                            break;
                        default:
                            tipo = 'Presencial';
                            break;
                    }

                    let corte1 = cont[i].corte_1;
                    let corte2 = cont[i].corte_2;
                    let corte3 = cont[i].corte_3;
                    let corte4 = cont[i].corte_4;
                    let corte5 = cont[i].corte_5;
                    let def = cont[i].def;

                    if (corte1 === null) corte1 = ""
                    if (corte2 === null) corte2 = ""
                    if (corte3 === null) corte3 = ""
                    if (corte4 === null) corte4 = ""
                    if (corte5 === null) corte5 = ""
                    if (def === null) def = ""
                    
                    contenido.push({
                        id: cont[i].id,
                        materia: cont[i].materia_name,
                        seccion: cont[i].nombre,
                        tipo: tipo,
                        uc: cont[i].u_c,
                        corte1: corte1,
                        corte2: corte2,
                        corte3: corte3,
                        corte4: corte4,
                        corte5: corte5,
                        def: def,
                    })
                }
            }
            respuesta(contenido)
        });
    })
}

export const ConsultaAcademicosEst = (est, respuesta) => {
        let Content = {
            est: est
        }
        Post(`${Url}academicosEstEstudiante`, Content, (resp) => {
            let data = JSON.parse(resp);
            let carreras = data[0];
            let materias = data[1];
            let semestres = data[2];

            if (data[0].length === 0) carreras = data[3]

            respuesta([carreras, materias, semestres])
        });
}


// WEBPACK FOOTER //
// ./src/funciones/RendAcadFunction.jsx